import axios from "axios";
import { API_BASE_URL, APP_VERSION } from "@/constants";
import util from "@/assets/js/util";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    accept: "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const userDataStr = localStorage.getItem("user_cms");

    if (!userDataStr) {
      return config;
    }

    try {
      const userData = JSON.parse(userDataStr);
      const role = userData?.role;

      if (!userData || userData.app_version !== APP_VERSION) {
        Object.keys(localStorage).forEach((key) => {
          localStorage.removeItem(key);
        });

        // Delay redirect untuk memberi waktu notifikasi muncul
        setTimeout(() => {
          window.location = "/login";
        }, 2000);

        console.log("DATA NOT VALID");

        // Reject promise agar error ditangkap dan ditampilkan
        return Promise.reject(
          new Error("Token tidak valid, silahkan login kembali."),
        );
      }

      if (userData.token) {
        config.headers.role = Array.isArray(role) ? "isafe" : role;
        config.headers.Authorization = `Bearer ${userData.token}`;
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
      util.showError("Error parsing user data, silahkan login kembali", 5000);
      // Delay redirect untuk memberi waktu notifikasi muncul
      setTimeout(() => {
        window.location = "/login";
      }, 2000);
      return Promise.reject(new Error("Error parsing user data"));
    }

    return config;
  },
  (error) => {
    util.showError("Error in request, silahkan login kembali", 5000);
    return Promise.reject(error);
  },
);

// Response interceptor untuk menangkap error dan menampilkan message dari Promise.reject
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Jika error berasal dari request interceptor (Promise.reject)
    // atau error lainnya, tampilkan message-nya
    if (error.message) {
      // Delay sedikit untuk memastikan UI siap menampilkan notifikasi
      setTimeout(() => {
        util.showError(error, 5000);
      }, 100);
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
